// extracted by mini-css-extract-plugin
export var box = "_1w-1";
export var checked = "_1w-2";
export var descriptionSpacer = "_1w-9";
export var disabled = "_1w-3";
export var icon = "_1w-6";
export var input = "_1w-0";
export var labelSpacer = "_1w-8";
export var medium = "_1w-5";
export var small = "_1w-4";
export var text = "_1w-7";